
export default {
  productData: {
    serialNumber: 'DA-MME-005',
    name: 'Massivholzdecke mit Estrich l Aufbau 5',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 60',
          value: 'w-60'
        },
        {
          type: 'insulation',
          title: { de: 'Holzfaserdämmplatte WF<br>(<i>s‘</i> ≤ 50 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 20',
          value: 'w-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 72 kg/m<sup>2</sup>), Rieselschutz' },
          output: '≥ 40',
          value: 'scsb-40'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Massivholzdecke (Steico GLVL)' },
          output: 120,
          value: 'mh-120'
        },
      ],
      sum: {
        output: '240', value: 240
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '58 (-1; 0)',
        value: 58
      },
      soundReductionIndex: { // Rw
        output: '62 (-4; -11)',
        value: 62
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,55',
        value: 0.55
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '296 [kg/m²]'
      }
    }
  },
  image: 'da-mme-005.png',
  pdf: 'Massivholzdecke-mit-Estrich-Aufbau-5-DA-MME-005-Rev01.pdf'
}
